import { render, staticRenderFns } from "./illness.vue?vue&type=template&id=38a77990&scoped=true&"
import script from "./illness.vue?vue&type=script&lang=js&"
export * from "./illness.vue?vue&type=script&lang=js&"
import style0 from "./illness.vue?vue&type=style&index=0&id=38a77990&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a77990",
  null
  
)

export default component.exports